module.exports = __webpack_public_path__ + "static/media/parcels.28a7ce9f.jpg";